import adminRequest from "@/api/adminRequest";

export const importLDAP = (formData) => {
    return adminRequest({
        url: '/import',
        method: 'get',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const importFile = (format, formData) => {
    return adminRequest({
        url: `/import/${format}`,
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}